import { render, staticRenderFns } from "./m-explain.vue?vue&type=template&id=59f8ebf0&scoped=true&"
import script from "./m-explain.vue?vue&type=script&lang=ts&"
export * from "./m-explain.vue?vue&type=script&lang=ts&"
import style0 from "./m-explain.vue?vue&type=style&index=0&id=59f8ebf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f8ebf0",
  null
  
)

export default component.exports